import { createSelector } from '@ngrx/store';

const selectSearch = (state: any) => {
  return state.search;
};

export const selectAllSearchesSuccess = createSelector(
  selectSearch,
  (state) => state.searches
);

export const selectAllSearchesFailure = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectNewSearchSuccess = createSelector(
  selectSearch,
  (state) => state.search
);

export const selectNewSearchFailure = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectReport = createSelector(
  selectSearch,
  (state) => state.report
);

export const selectArchiveReportSuccess = createSelector(
  selectSearch,
  (state) => state.archived_report
);

export const selectArchiveReportFailure = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectRestoreReportSuccess = createSelector(
  selectSearch,
  (state) => state.restored_report
);

export const selectRestoreReportFailure = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectReportError = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectAllNotesSuccess = createSelector(
  selectSearch,
  (state) => state
);

export const selectAllNotesFailure = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectAssistantHistorySuccess = createSelector(
  selectSearch,
  (state) => state.history
);

export const selectAssistantHistoryFailure = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectAskAssistantSuccess = createSelector(
  selectSearch,
  (state) => state.assistant_response
);

export const selectAskAssistantFailure = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectDeleteNoteSuccess = createSelector(
  selectSearch,
  (state) => state
);

export const selectDeleteNoteFailure = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectCreateNoteSuccess = createSelector(
  selectSearch,
  (state) => state
);

export const selectCreateNoteFailure = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectGetNotesSummarySuccess = createSelector(
  selectSearch,
  (state) => state
);

export const selectGetNotesSummaryFailure = createSelector(
  selectSearch,
  (state) => state.error
);
export const selectShowMoreNotesSuccess = createSelector(
  selectSearch,
  (state) => state
);

export const selectShowMoreNotesFailure = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectEditNoteSuccess = createSelector(
  selectSearch,
  (state) => state
);

export const selectEditNoteFailure = createSelector(
  selectSearch,
  (state) => state.error
);
export const selectLoading = createSelector(
  selectSearch,
  (state) => state.loading
);

export const selectEventStatuses = createSelector(
  selectSearch,
  (state) => state?.eventStatuses || {}
);

export const selectIsLoading = (searchId: number) =>
  createSelector(
    selectEventStatuses,
    (statuses) => statuses[searchId]?.isLoading ?? true
  );

// Selector to fetch event statuses for a given searchId
export const selectEventStatusesBySearchId = (searchId: number) =>
  createSelector(
    selectEventStatuses,
    (eventStatuses) =>
      eventStatuses[searchId] || {
        companyRevenue: false,
        companyProfit: false,
        companyFunding: false,
        companyEmployees: false,
      }
  );

// Selector to check if all events are complete for a given searchId
export const selectAreAllEventsComplete = (searchId: number) =>
  createSelector(selectEventStatusesBySearchId(searchId), (eventStatuses) => {
    // Ensure all statuses are complete
    const allComplete =
      eventStatuses.companyRevenue &&
      eventStatuses.companyProfit &&
      eventStatuses.companyFunding &&
      eventStatuses.companyEmployees;

    // Optional: Debug log to check the statuses during development
    // console.log(`Event statuses for searchId ${searchId}:`, eventStatuses, 'All Complete:', allComplete);

    return allComplete;
  });

export const selectFuzzySearchResults = createSelector(
  selectSearch,
  (state) => state.fuzzySearchResults
);

export const selectFuzzySearchLoading = createSelector(
  selectSearch,
  (state) => state.fuzzySearchLoading
);

export const selectFuzzySearchError = createSelector(
  selectSearch,
  (state) => state.error
);

export const selectEnrichmentLoading = createSelector(
  selectSearch,
  (state) => state.enrichmentLoading
);

export const selectEnrichmentData = createSelector(
  selectSearch,
  (state) => state.enrichmentData
);

export const selectEnrichmentError = createSelector(
  selectSearch,
  (state) => state.enrichmentError
);

export const selectReportEnrichStatus = createSelector(
  selectSearch,
  (state) => state.reportEnrichStatus
);

export const selectInsightsLoading = createSelector(
  selectSearch,
  (state) => state.insightsLoading
);

export const selectInsightsData = createSelector(
  selectSearch,
  (state) => state.insightsData
);

export const selectInsightsError = createSelector(
  selectSearch,
  (state) => state.insightsError
);

export const selectCurrentInsightType = createSelector(
  selectSearch,
  (state) => state.currentInsightType
);

export const selectRevenueUpdateLoading = createSelector(
  selectSearch,
  (state) => state.revenueUpdateLoading
);

export const selectRevenueUpdateData = createSelector(
  selectSearch,
  (state) => state.revenueUpdateData
);

export const selectRevenueUpdateError = createSelector(
  selectSearch,
  (state) => state.revenueUpdateError
);

export const selectContactInfoUpdateLoading = createSelector(
  selectSearch,
  (state) => state.contactInfoUpdateLoading
);

export const selectContactInfoUpdateData = createSelector(
  selectSearch,
  (state) => state.contactInfoUpdateData
);

export const selectContactInfoUpdateError = createSelector(
  selectSearch,
  (state) => state.contactInfoUpdateError
);
